<template>
    <div>
        <ul>
            <li class="form-label">{{ $t('SIP_TRUNK') }}</li>
            <li>
                <cic-select
                    id="route_trunk"
                    :enabled="editing"
                    :options="trunks.map((x) => ({ value: x.trunkId, label: x.name }))"
                    :placeholder="$t('Please select...')"
                    :value="route.trunkId"
                    @input="(val) => updateFieldValue('trunkId', val)"
                />
            </li>
            <template v-if="route.trunkId > 0">
                <li class="form-label">{{ $t('Pass through access number as outbound number') }}</li>
                <li>
                    <cic-checkbox
                        id="route_passthrough"
                        :enabled="editing"
                        :value="route.number === ''"
                        @input="(val) => updateFieldValue('number', val ? '' : null)"
                    />
                </li>
                <template v-if="route.number !== ''">
                    <li class="form-label">{{ $t('OUTBOUND_NUMBER') }}</li>
                    <li>
                        <cic-textbox
                            id="route_number"
                            :maxlength="255"
                            :enabled="editing"
                            :value="route.number"
                            @input="(val) => updateFieldValue('number', val)"
                        />
                    </li>
                </template>
                <li class="form-label">{{ $t('Ringing Timeout (secs)') }}</li>
                <li>
                    <cic-textbox
                        id="route_timeout"
                        :maxlength="3"
                        :enabled="editing"
                        :value="route.ringingTimeout"
                        int-only
                        @input="(val) => updateFieldValue('ringingTimeout', val)"
                    />
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'SIPTrunk',
        components: {
            CicCheckbox,
            CicSelect,
            CicTextbox,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
            trunks: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
